import AnalyticsListItem from "./AnalyticsListItem";
import AnalyticsReport from "./AnalyticsReport";
import AnalyticsTimeSeriesRecord from "./AnalyticsTimeSeriesRecord";
import AnalyticsCount from "./AnalyticsCount";
import Chatter from "./Chatter";
import ChatterNew from "./ChatterNew";
import Client from "./Client";
import Conversation from "./Conversation";
import CSATSettings from "./CSATSettings";
import Language from "./Language";
import MessageTemplate from "./MessageTemplate";
import Response from "./Response";
import ResponseFilterItem from "./ResponseFilterItem";
import ResponseSideBar from "./ResponseSideBar";
import StatsAnswersOverviewRecord from "./StatsAnswersOverviewRecord";
import StatsAnswersPerformanceRecord from "./StatsAnswersPerformanceRecord";
import StatsConversationsOverviewRecord from "./StatsConversationsOverviewRecord";
import StatsSatisfactionRecord from "./StatsSatisfactionRecord";
import User from "./User";
import Agent from "./Agent";

export interface ResourceModelTypes {
  analyticsReport: AnalyticsReport;
  analyticsTimeSeriesRecord: AnalyticsTimeSeriesRecord;
  analyticsListItem: AnalyticsListItem;
  client: Client;
  conversation: Conversation;
  csatSettings: CSATSettings;
  language: Language;
  response: Response;
  responseFilterItem: ResponseFilterItem;
  responseSideBar: ResponseSideBar;
  user: User;
  agent: Agent;
}

export type ResourceType = keyof ResourceModelTypes;

type ResourceModel = ResourceModelTypes[ResourceType];

const allResourceModels = [
  AnalyticsListItem,
  AnalyticsReport,
  AnalyticsTimeSeriesRecord,
  AnalyticsCount,
  Chatter,
  ChatterNew, // This is to replace `Chatter` when convo filtering is released
  Client,
  Conversation,
  CSATSettings,
  Language,
  MessageTemplate,
  Response,
  ResponseSideBar,
  ResponseFilterItem,
  StatsAnswersOverviewRecord,
  StatsAnswersPerformanceRecord,
  StatsConversationsOverviewRecord,
  StatsSatisfactionRecord,
  User,
  Agent
];

export function getModelByResourceType(resourceType: ResourceType): ResourceModel {
  const resourceModelsKeyedByType: Partial<ResourceModelTypes> = (
    allResourceModels.reduce((result, Model) => ({
      ...result,

      // Remove this when all models are converted to TS
      [Model.type]: Model
    }), {})
  );

  const ResultModel = resourceModelsKeyedByType[resourceType];

  if (!ResultModel) {
    throw new Error(`A model with type "${resourceType}" not found`);
  }

  return ResultModel;
}

export {
  AnalyticsListItem,
  AnalyticsReport,
  AnalyticsTimeSeriesRecord,
  AnalyticsCount,
  Chatter,
  ChatterNew, // This is to replace `Chatter` when conversation filtering is released
  Client,
  Conversation,
  CSATSettings,
  Language,
  MessageTemplate,
  Response,
  ResponseFilterItem,
  ResponseSideBar,
  StatsAnswersOverviewRecord,
  StatsAnswersPerformanceRecord,
  StatsConversationsOverviewRecord,
  StatsSatisfactionRecord,
  User,
  Agent
};
